var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInhabitantsVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ADAAE3",
    d: "M343-470ZM80-120v-480l320-240 215 162q-25 3-47 11.5T526-644l-126-96-240 180v360h160v80H80Zm320 0v-76q0-21 10.5-39.5T439-265q46-27 96.5-41T640-320q54 0 104.5 14t96.5 41q18 11 28.5 29.5T880-196v76H400Zm86-80h308q-35-20-74-30t-80-10q-41 0-80 10t-74 30Zm154-160q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T680-480q0-17-11.5-28.5T640-520q-17 0-28.5 11.5T600-480q0 17 11.5 28.5T640-440Zm0 240Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInhabitantsVisitors);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPgo8cGF0aCBmaWxsPSIjQURBQUUzIiBkPSJNMzQzLTQ3MFpNODAtMTIwdi00ODBsMzIwLTI0MCAyMTUgMTYycS0yNSAzLTQ3IDExLjVUNTI2LTY0NGwtMTI2LTk2LTI0MCAxODB2MzYwaDE2MHY4MEg4MFptMzIwIDB2LTc2cTAtMjEgMTAuNS0zOS41VDQzOS0yNjVxNDYtMjcgOTYuNS00MVQ2NDAtMzIwcTU0IDAgMTA0LjUgMTR0OTYuNSA0MXExOCAxMSAyOC41IDI5LjVUODgwLTE5NnY3Nkg0MDBabTg2LTgwaDMwOHEtMzUtMjAtNzQtMzB0LTgwLTEwcS00MSAwLTgwIDEwdC03NCAzMFptMTU0LTE2MHEtNTAgMC04NS0zNXQtMzUtODVxMC01MCAzNS04NXQ4NS0zNXE1MCAwIDg1IDM1dDM1IDg1cTAgNTAtMzUgODV0LTg1IDM1Wm0wLTgwcTE3IDAgMjguNS0xMS41VDY4MC00ODBxMC0xNy0xMS41LTI4LjVUNjQwLTUyMHEtMTcgMC0yOC41IDExLjVUNjAwLTQ4MHEwIDE3IDExLjUgMjguNVQ2NDAtNDQwWm0wIDI0MFoiLz4KPC9zdmc+";
export { ForwardRef as ReactComponent };